import React from 'react'
import { useNavigate } from 'react-router-dom'

function Error() {
    const navigate = useNavigate()

    const handleMove = () => {
        navigate("/dashboard")
    }
    return (
        <div className='grid grid-cols-12 bg-[#e29c29] fontNew'>
            <div className="col-span-12 flex justify-center items-center h-screen p-3">
                <div className='text-white text-center'>
                    <p className='sm:text-[100px] text-[80px] font-medium p-0'>404</p>
                    <p className='sm:text-3xl text-2xl mb-5'>Oops. This page has gone missing.</p>
                    <p className='my-5'>The page you are looking for might have been removed had its <br /> name changed or is temporarily unavailable</p>
                    <button onClick={handleMove} className='bg-white px-4 py-2 text-[#e29c29] rounded-lg font-medium mt-4'>Back to Dashboard Page</button>
                </div>
            </div>
        </div>
    )
}

export default Error